





































































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";

@Component({})
export default class CiudadanoCollapse extends Vue {
  @Prop() public action!: string;
  @Prop() public controller!: string;
  @Prop() public whereParams!: string;
  @Prop() public include!: string;
  @Prop() public value!: number | any;
  @Prop() public cedula!: string;
  @Prop() public actaNac!: string;
  @Prop() public closable!: boolean;
  @Prop() public closeTitle!: string;
  @Prop() public title!: string;
  @Prop() public hideSexo!: boolean;
  @Prop() public hideNombre!: boolean;

  loading = false;

  ciudadano = null;
  client = new HttpClient(this.controller || "personas");

  get isCosable() {
    return this.closable === false ? false : true;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  queryParams(): ApiQueryOption {
    let instace = new ApiQueryOption();
    instace.where = this.whereParams;
    instace.include = this.include;
    if (instace.where) {
      if (this.cedula) {
        let ced = this.cedula.replace(/-/g, "");
        instace.where += `cedula="${ced}"`;
      } else if (this.actaNac) {
        instace.where += `actaNac="${this.actaNac}"`;
      }
    } else {
      if (this.cedula) {
        let ced = this.cedula.replace(/-/g, "");
        instace.where = `cedula="${ced}"`;
      } else if (this.actaNac) {
        instace.where = `actaNac="${this.actaNac}"`;
      }
    }

    if (!instace.include) delete instace.include;
    return instace;
  }
  get isId() {
    return !isNaN(this.value);
  }

  async getDataAsync() {
    try {
      this.loading = true;
      let resource = this.action || String();
      if (this.value && this.isId) {
        resource += `${this.value}`;
      }
      let result = await this.client.getAsync<any>(
        resource,
        this.queryParams()
      );

      if (resource) {
        this.ciudadano = result;
        this.$emit("input", result ? result.id : null);
      } else {
        this.ciudadano = result[0];
        this.$emit("input", this.ciudadano);
      }

      this.$emit("change", this.ciudadano);
    } catch (e) {
      this.ciudadano = null;
      this.$emit("change", null);
    } finally {
      this.loading = false;
    }
  }

  getFoto(value: string) {
    return `data:image/jpg;base64, ${value}`;
  }
  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.ciudadano = null;
      return;
    }
    if (isNaN(value)) {
      this.ciudadano = this.value;
      this.$emit("change", value);
    } else {
      this.getDataAsync();
    }
  }
  @Watch("cedula")
  onCedula(value: any) {
    if (!value) {
      this.ciudadano = null;
      return;
    }
    this.getDataAsync();
  }
  @Watch("actaNac")
  onActa(value: any) {
    if (!value) {
      this.ciudadano = null;
      return;
    }
    this.getDataAsync();
  }

  close() {
    this.ciudadano = null;
    this.$emit("close", null);
    this.$emit("input", null);
  }
}
